/**
 * Query keys for budgeting method queries
 * Using object-based hierarchical query keys following amendment pattern
 */

type BudgetingMethodDetailParams = {
  companyId: string
  accountCode: string | number
}

type BudgetingMethodStatementParams = {
  accountCode: string | number
  budgetingScenarioId?: number | null
}

export const budgetingMethodQueryKeys = {
  all: [{ scope: 'budgetingMethod' }] as const,
  lists: () => [{ ...budgetingMethodQueryKeys.all[0], entity: 'list' }] as const,
  list: (companyId: string) => [{ ...budgetingMethodQueryKeys.lists()[0], companyId }] as const,
  details: () => [{ ...budgetingMethodQueryKeys.all[0], entity: 'detail' }] as const,
  detail: (params: BudgetingMethodDetailParams) => [{ ...budgetingMethodQueryKeys.details()[0], ...params }] as const,
  statements: () => [{ ...budgetingMethodQueryKeys.all[0], entity: 'statement' }] as const,
  statement: (params: BudgetingMethodStatementParams) =>
    [{ ...budgetingMethodQueryKeys.statements()[0], ...params }] as const
}
